<style>
.categorias-container {
    margin-top: 35px; /* Espacio de 25px desde la parte superior */
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background-color: #121826; /* Fondo oscuro */
    border-radius: 8px; /* Bordes redondeados */
    margin-bottom: 20px; /* Espacio inferior */
}
</style>

<div class="categorias-container">
    <!-- Menú de Categorías -->
    <nav class="menu" *ngIf="!esMovil">
        <ul>
            <li *ngFor="let categoria of categorias[idiomaSeleccionado]" 
                (click)="seleccionarCategoria(categoria)" 
                [class.activa]="categoria === categoriaSeleccionada">
                {{ categoria }}
            </li>
        </ul>
    </nav>

    <!-- Selector de Categoría en Móvil -->
    <select class="categoria-selector" *ngIf="esMovil" [(ngModel)]="categoriaSeleccionada" (change)="seleccionarCategoria(categoriaSeleccionada)">
        <option *ngFor="let categoria of categorias[idiomaSeleccionado]" [value]="categoria">{{ categoria }}</option>
    </select>

    <!-- Selector de idioma -->
    <select class="idioma-selector" [(ngModel)]="idiomaSeleccionado" (change)="cambiarIdioma($event)">
        <option value="es">Español</option>
        <option value="en">English</option>
    </select>
</div>

<!-- Contenido de los mangas -->
<div class="contenedor">
    <div class="manga-card" *ngFor="let manga of mangas">
        <img [src]="manga.imagen" [alt]="manga.titulo">
        <h3>{{ manga.titulo }}</h3>
        <p>{{ manga.autor }}</p>
    </div>
</div>



